"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var material_kit_pro_react_1 = require("../../../assets/jss/material-kit-pro-react");
var styles = function (theme) {
    var _a;
    return (0, styles_1.makeStyles)({
        root: __assign(__assign({}, material_kit_pro_react_1.container), { paddingLeft: 0, paddingRight: 0 }),
        field: {
            width: '100%',
            marginTop: theme.spacing(),
            marginBottom: theme.spacing(),
            paddingBottom: theme.spacing()
        },
        fieldAutocomplete: (_a = {
                width: '100%',
                marginTop: theme.spacing(),
                marginBottom: theme.spacing(),
                paddingBottom: theme.spacing(),
                '& .MuiAutocomplete-clearIndicatorDirty': {
                    visibility: 'visible',
                    opacity: 0
                }
            },
            _a['& .MuiAutocomplete-clearIndicatorDirty:focus,' +
                ' &:hover .MuiAutocomplete-clearIndicatorDirty,' +
                ' &.Mui-focused .MuiAutocomplete-clearIndicatorDirty'] = {
                opacity: 100
            },
            _a['& .MuiAutocomplete-clearIndicatorDirty:focus'] = {
                background: theme.palette.action.hover
            },
            _a)
    });
};
exports.default = styles;
//# sourceMappingURL=AddressStyle.js.map